import React, { ReactNode, ReactNodeArray, useContext } from 'react';

import { TabContext } from './TabContext';

interface IProps {
  value: number | string;
  children: string | ReactNode | ReactNodeArray;
  visible?: boolean;
}

function TabPanel({ value, children, visible }: IProps) {
  const { id, value: activeValue, destroyWhenHidden } = useContext(TabContext);

  const isSelected = value === activeValue || visible;
  return (
    <article
      id={`panel-${id}-${value}`}
      className="novoTabPanel"
      role="tabpanel"
      aria-labelledby={`tab-${id}-${value}`}
      hidden={!isSelected}
    >
      {!isSelected && destroyWhenHidden ? null : children}
    </article>
  );
}

export default TabPanel;
